<template>
  <div class="alert">
    <slot></slot>
  </div>
</template>
